import { render, staticRenderFns } from "./GmShop.vue?vue&type=template&id=64a92095&"
import script from "./GmShop.vue?vue&type=script&lang=js&"
export * from "./GmShop.vue?vue&type=script&lang=js&"
import style0 from "./GmShop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports